import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	provisioningBackgroundTitle: {
		id: 'confluence.project-pages.improvement.provisioning-background.title',
		defaultMessage: 'Setting up your Project Pages',
		description:
			'Heading in provisioning in progress screen, informing users that Project Pages is currently being set up.',
	},
	provisioningBackgroundText: {
		id: 'confluence.project-pages.improvement.provisioning-background.text',
		defaultMessage: 'This should take less than a minute',
		description: 'Sentence informing users that provisioning will be done in no time',
	},
});

export default messages;
